"use strict";

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var CreditCardHelper = {
	_getStore: function() {
		if (window.CheckoutStore) {
			return window.CheckoutStore;
		}

		return window.AccountStore;
	},

	handleExpirationDateInputFormat: function (event) {
		var value = $(event.currentTarget).val() || "";

		var hasSlash = value.substring(2, 3) === "/";

		value = value.replace("/", "").replace(/[^\d]+/g, "");

		if (value.length === 2) {
			if (!event.which || event.which === Constants.KEYS.BACKSPACE) {
				//No more formatting is necessary
				return;
			}

			value = `${value}${(hasSlash ? "/": "")}`;
		} else if (value.length > 2) {
			value = `${value.substring(0, 2)}/${value.substring(2)}`;
		}

		if (value.length > 5) {
			value = value.substring(0, 5);
		}

		$(event.currentTarget).val(value);
	},

	handleVerificationNumberInputFormat: function (event) {
		var value = $(event.currentTarget).val() || "";

		value = value.replace(/[^\d]+/g, "");

		if (value.length > 4) {
			value = value.substring(0, 4);
		}

		$(event.currentTarget).val(value);
	},

	initializeListeners: function($parent) {
		$parent = $parent || $("body");

		$parent.find("input[data-component='creditCardExpirationDate']").each((index, element) => {
			var $element = $(element);
			$element.attr("data-has-custom-validator", true).data({customValidator: this.validateExpirationDate.bind(this, $element)});
		});

		$parent.find("input[data-component='creditCardVerificationNumber']").each((index, element) => {
			var $element = $(element);
			$element.attr("data-has-custom-validator", true).data({customValidator: this.validateVerificationNumber.bind(this, $element)});
		});

		$parent.find("input[data-component='creditCardExpirationDate'], input[data-component='creditCardVerificationNumber']").keydown((event) => {
			//If Ctrl or (Window for WindowsOS or Command for MacOS) or Alt key or some of the text is selected, allow the key down
			if (event.ctrlKey || event.metaKey || event.altKey || (event.currentTarget.selectionEnd - event.currentTarget.selectionStart > 0)) {
				return true;
			}
			switch (event.which) {
				case Constants.KEYS.DELETE:
				case Constants.KEYS.BACKSPACE:
				case Constants.KEYS.ARROW_UP:
				case Constants.KEYS.ARROW_RIGHT:
				case Constants.KEYS.ARROW_DOWN:
				case Constants.KEYS.ARROW_LEFT:
				case Constants.KEYS.TAB:
				case Constants.KEYS.ESCAPE:
				case Constants.KEYS.HOME:
				case Constants.KEYS.END:
				case Constants.KEYS.PAGE_UP:
				case Constants.KEYS.PAGE_DOWN:
					//event not handled, allowing the key down, as this is not a printable character
					return true;
				default:
					var value = $(event.currentTarget).val() || "";
					if (value.length >= 5) {
						//event handled, do not allow key down, already at max characters
						return false;
					}
					//event not handled, allow the key down
					return true;
			}
		});

		$parent.find("input[data-component='creditCardExpirationDate']").change((event) => this.handleExpirationDateInputFormat(event));
		$parent.find("input[data-component='creditCardExpirationDate']").keyup((event) => this.handleExpirationDateInputFormat(event));

		$parent.find("input[data-component='creditCardVerificationNumber']").change((event) => this.handleVerificationNumberInputFormat(event));
		$parent.find("input[data-component='creditCardVerificationNumber']").keyup((event) => this.handleVerificationNumberInputFormat(event));
	},

	validateExpirationDate: function($expirationDate) {
		var errorMessages = [];

		var expirationDateString = $expirationDate.val();

		if (expirationDateString && expirationDateString.length === 5) {
			var monthString = expirationDateString.slice(0, 2);
			var monthNumber = Number(monthString);
			if (!monthNumber || monthNumber < 1 || monthNumber > 12) {
				var expirationMonthMessage = this._getStore().getWizardValue(
					WizardConstants.WIZARDS.CREDIT_CARD_MESSAGES,
					WizardConstants.CREDIT_CARD_MESSAGE_FIELDS.EXPIRATION_MONTH_INVALID
				);

				errorMessages.push(expirationMonthMessage);
			}

			var currentYearString = (new Date()).getFullYear().toString().slice(-2);
			var currentYearNumber = Number(currentYearString);
			var yearString = expirationDateString.slice(3);
			var yearNumber = Number(yearString);
			if (!yearNumber || yearNumber < currentYearNumber || yearNumber > 99) {
				var expirationYearMessage = this._getStore().getWizardValue(
					WizardConstants.WIZARDS.CREDIT_CARD_MESSAGES,
					WizardConstants.CREDIT_CARD_MESSAGE_FIELDS.EXPIRATION_YEAR_INVALID
				);

				errorMessages.push(expirationYearMessage);
			}
		} else {
			var expirationDateIncompleteMessage = this._getStore().getWizardValue(
				WizardConstants.WIZARDS.CREDIT_CARD_MESSAGES,
				WizardConstants.CREDIT_CARD_MESSAGE_FIELDS.EXPIRATION_DATE_INCOMPLETE
			);

			errorMessages.push(expirationDateIncompleteMessage);
		}

		return { isValid : !errorMessages.length, errorMessages : errorMessages };
	},

	validateVerificationNumber: function($verificationNumber) {
		var errorMessages = [];

		var verificationNumberString = $verificationNumber.val();

		if (!verificationNumberString || verificationNumberString.length < 3 || verificationNumberString.length > 4) {
			var verificationNumberIncompleteMessage = this._getStore().getWizardValue(
				WizardConstants.WIZARDS.CREDIT_CARD_MESSAGES,
				WizardConstants.CREDIT_CARD_MESSAGE_FIELDS.VERIFICATION_NUMBER_INVALID
			);

			errorMessages.push(verificationNumberIncompleteMessage);
		}

		return { isValid : !errorMessages.length, errorMessages : errorMessages };
	}
};

module.exports = CreditCardHelper;
